import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    background: white;
    position: relative;
    .MuiTabs-indicator {
      height: ${pxToRem(3)};
      border-radius: 2px;
      background-color: ${colors.leaf};
    }
    &.MuiTabs-root {
      min-height: ${pxToRem(35)} !important;
      overflow: visible !important;
    }
    & > .MuiTabs-fixed {
      overflow: visible !important;
    }
  `,
  tab: css`
    &.MuiTab-root {
      text-transform: capitalize;
      padding: 0px;
      min-height: ${pxToRem(33)};
    }
    &.MuiTab-root.Mui-focusVisible, &:focus-visible {
      outline-offset: 2px;
    }
  `,
  disabledTab: css`
    color: ${colors.stone} !important;
  `,
  tabIndicator: css`
    height: 3px;
    border-radius: 2px;
    background-color: ${colors.leaf};
    width: 50%;
    bottom: 0;
    position: absolute;
  `,
};

export default styles;
